<template>
  <div class="home">
    <NavigationBar />
    <Breadcrumb breadcrumbText="Experienced Chefs" />
    <Team />
    <Video />
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import NavigationBar from "@/components/NavigationBar.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Team from "@/components/Team.vue";
import Video from "@/components/Video.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "chefs",
  components: {
    NavigationBar,
    Breadcrumb,
    Team,
    Video,
    Footer
  }
};
</script>
